import { SETAPPS } from '../action-types/applicationsActionTypes'

const initialState = []

const applicationsReducer = (state = initialState, action) => {
	switch (action.type) {
		case SETAPPS:
			return action.payload
		default:
			return state
	}
}

export default applicationsReducer
